import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initialValues";

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveTokenTask(state, action) {
      state.info = action.payload;
    },
    logout(state, action) {
      return initialState;
    },
    addItemOrQtyToCart: {
      reducer: (state, action) => {
        const findProduct = state.products.find(
          (product) => product.name === action.payload.name
        );
        if (!findProduct) {
          state.products.push(action.payload);
        } else if (findProduct && findProduct.qty < findProduct.stock) {
          findProduct.qty = findProduct.qty + action.payload.qty;
        } else {
          return state;
        }
      },
      prepare: (product) => {
        return {
          payload: {
            id: product._id,
            name: product.name,
            image: product.image,
            type: product.type,
            price: product.price,
            slug: product.slug,
            stock: product.stock,
            description: product.description,
            qty: 1,
          },
        };
      },
    },
    removeItemFromCart: {
      reducer: (state, action) => {
        state.products = state.products.filter(
          (product) => product.name !== action.payload.name
        );
      },
      prepare: (product) => {
        return {
          payload: product,
        };
      },
    },
    removeProductQuantity: {
      reducer: (state, action) => {
        const findProduct = state.products.find(
          (product) => product.name === action.payload.name
        );
        findProduct.qty = findProduct.qty - 1;
      },
      prepare: (product) => {
        return {
          payload: product,
        };
      },
    },
    clearCart(state, action) {
      state.products = [];
    },
  },
});

const { actions, reducer } = userSlice;
export const {
  saveTokenTask,
  logout,
  addItemOrQtyToCart,
  removeItemFromCart,
  removeProductQuantity,
  clearCart,
} = actions;
export default reducer;
